import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"

import { cn } from "#Utils/cn"

const REMARK_PLUGINS = [remarkGfm]

const Markdown = ({ children, className, ...props }) => (
  <div className={cn("c-markdown max-w-none", className)} {...props}>
    <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{children}</ReactMarkdown>
  </div>
)

Markdown.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default Markdown
